import { toCitySlug } from '@/utils/formatters/city/to-city-slug.util';
import { slugify } from '@/utils/formatters/slugfy';

interface CityCandidate {
  city?: string | null;
  state?: string | null;
}

export const normalizeCitySlug = (value?: string | null): string | undefined =>
  value ? slugify(value) : undefined;

export function resolveCitySlug(
  cityParam?: string | null,
  userLocation?: CityCandidate | null,
  fallback?: CityCandidate | null,
): string | undefined {
  return normalizeCitySlug(cityParam)
    ?? toCitySlug(userLocation?.city, userLocation?.state)
    ?? toCitySlug(fallback?.city, fallback?.state);
}
